import { css, styled } from "@/root/stitches.config";
import { Title } from "../title";

import InstagramIcon from "@/assets/icons/instagram.svg";
import TiktokIcon from "@/assets/icons/tiktok.svg";

const socials = [
    {
        id: 1,
        label: "@jfestbali",
        href: "https://instagram.com/jfestbali",
        icon: InstagramIcon,
    },
    {
        id: 2,
        label: "@jfest.bali",
        href: "https://www.tiktok.com/@jfest.bali?lang=id-ID",
        icon: TiktokIcon,
    },
];

const SocialLink = styled("a", {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "1rem",
    color: "$white",
    fontFamily: "$main",
    fontSize: "1vw",
    letterSpacing: 2,
    textDecoration: "none",
    textDecorationColor: "transparent",
    "&:hover": {
        textDecoration: "underline",
        textDecorationColor: "$white",
    },
    "@mobile": {
        fontSize: "1rem",
    },
});

export default function FooterSocials() {
    return (
        <section
            className={css({
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gridColumn: "10 / -1",
                paddingTop: "8.7rem",
                gap: "1.5rem",
                zIndex: 2,
                "@tablet": {
                    gridColumn: "7 / -1",
                    paddingTop: "1.5rem",
                },
                "@mobile": {
                    gridColumn: "1 / -1",
                    paddingTop: "1.5rem",
                },
            }).toString()}
        >
            <Title
                order={2}
                css={{
                    fontSize: "1.25rem",
                    color: "$white",
                }}
            >
                Social Media
            </Title>

            <div
                className={css({
                    display: "flex",
                    flexDirection: "column",
                    gap: "1.25rem",
                }).toString()}
            >
                {socials.map((social) => (
                    <SocialLink
                        key={social.id}
                        href={social.href}
                        target="_blank"
                    >
                        <img
                            src={social.icon}
                            alt={social.label}
                            style={{
                                width: "1.45rem",
                                height: "1.45rem",
                            }}
                        />

                        <span>{social.label}</span>
                    </SocialLink>
                ))}
            </div>
        </section>
    );
}